<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { AUTOMATION_RULE_EVENTS, SUGAR_TRIGGERS } from './constants';

// The trigger the rule listens for. Changing it swaps the whole set of
// available conditions, which is why the form warns that they get reset.
defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: '',
  },
  showResetWarning: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:modelValue']);

const { t } = useI18n();

// The plain events come first, then the triggers that stand for a specific
// attribute changing.
const events = computed(() =>
  [...AUTOMATION_RULE_EVENTS, ...SUGAR_TRIGGERS].map(event => ({
    key: event.key,
    label: t(`AUTOMATION.EVENTS.${event.value}`),
  }))
);
</script>

<template>
  <div class="mb-6">
    <label :class="{ error }">
      {{ $t('AUTOMATION.ADD.FORM.EVENT.LABEL') }}
      <select
        class="m-0"
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
      >
        <option v-for="event in events" :key="event.key" :value="event.key">
          {{ event.label }}
        </option>
      </select>
      <span v-if="error" class="message">
        {{ $t('AUTOMATION.ADD.FORM.EVENT.ERROR') }}
      </span>
    </label>
    <p
      v-if="showResetWarning"
      class="pt-1 text-xs text-right text-green-500 dark:text-green-500"
    >
      {{ $t('AUTOMATION.FORM.RESET_MESSAGE') }}
    </p>
  </div>
</template>
